module.exports = __webpack_public_path__ + "img/project-bg.fa416f4a.png";